module.exports = __webpack_public_path__ + "img/logo_namur.fdedc5cd.png";